var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "label-control",
          {
            staticClass: "col-xs-12 col-sm-5 col-form-label",
            attrs: {
              title: _vm.title,
              instructionKey: _vm.title_instructions,
              required: true
            }
          },
          [_vm._v(_vm._s(_vm.$t(_vm.title)))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "ul",
      { key: _vm.apartmentKey, staticClass: "accordion list-unstyled" },
      _vm._l(_vm.apartments, function(apartment, index) {
        return _c(
          "li",
          { key: "aparment-" + index, staticClass: "group-wrapper mb-3" },
          [
            _c("div", { class: "row heading-div " + "apartment-" + index }, [
              _c(
                "button",
                {
                  class: [
                    _vm.isExpanded(index) ? "" : "collapsed",
                    "tab-button btn col apartment-" + index
                  ],
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#collapse" + index,
                    "aria-controls": "collapse" + index,
                    "aria-expanded": _vm.isExpanded(index).toString()
                  },
                  on: {
                    click: function($event) {
                      return _vm.collapseEvent(index)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-plus fa-lg" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-minus fa-lg" }),
                  _vm._v(" "),
                  _c("header-control", {
                    attrs: {
                      title: _vm.apartmentTitle(apartment, index),
                      id: "apartment-" + index,
                      doNotUseResources: true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isReadOnly
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: { html: true, content: _vm.duplicateTooltip },
                          expression:
                            "{ html: true, content: duplicateTooltip }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "btn btn-link right col-auto",
                      attrs: {
                        type: "button",
                        "aria-label":
                          _vm.$t(
                            "InvestmentReport.Finances.ApartmentAcquisitions.DuplicateApartment"
                          ) +
                          (index + 1)
                      },
                      on: {
                        click: function($event) {
                          return _vm.duplicateApartment(apartment)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-copy fa-lg" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.apartments.length > 1 && !_vm.isReadOnly
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-link right col-auto",
                      attrs: {
                        type: "button",
                        "aria-label":
                          _vm.$t(
                            "InvestmentReport.Finances.ApartmentAcquisitions.DeleteApartment"
                          ) +
                          (index + 1) +
                          " " +
                          _vm.$t("Accessibility.ConfirmDeleteApartment")
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteApartment(apartment)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash-alt fa-lg" })]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [_vm.isExpanded(index) ? "show" : "", "collapse"],
                attrs: { id: "collapse" + index }
              },
              [
                _c("apartment-control", {
                  attrs: { apartment: apartment, index: index }
                })
              ],
              1
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    !_vm.isReadOnly
      ? _c("div", { staticClass: "mt-3" }, [
          _vm.apartments.length < 100
            ? _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.create()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "InvestmentReport.Finances.ApartmentAcquisitions.AddApartment"
                      )
                    )
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: {
                    type: "button",
                    disabled: "",
                    "aria-disabled": "true"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "InvestmentReport.Finances.ApartmentAcquisitions.AddApartment"
                      )
                    )
                  )
                ]
              )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("h4", { attrs: { id: "ApartmentTotals" } }, [
      _vm._v(
        _vm._s(_vm.$t("InvestmentReport.Finances.ApartmentAcquisitions.Totals"))
      )
    ]),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "mt-3 table tablerow",
        attrs: { "aria-labelledby": "ApartmentTotals" }
      },
      [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.Finances.ApartmentAcquisitions.TotalEuro"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("th", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.Finances.ApartmentAcquisitions.FreeOfDebtPrices"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("th", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.Finances.ApartmentAcquisitions.TransferTaxes"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("th", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.Finances.ApartmentAcquisitions.RepairCostTotal"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("th", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.Finances.ApartmentAcquisitions.GrandTotalCosts"
                    )
                  )
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.title)))])]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.freeOfDebtPrices)))
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.transferTaxes)))
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.repairCosts)))
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.grandTotal)))
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }